"use strict";
var Observable_1 = require('../../Observable');
var every_1 = require('../../operator/every');
Observable_1.Observable.prototype.every = every_1.every;
//# sourceMappingURL=every.js.map


//////////////////
// WEBPACK FOOTER
// /app/~/rxjs/add/operator/every.js
// module id = ../../../../rxjs/add/operator/every.js
// module chunks = 7